import CustomInput from "../../eventcreation/components/CustomInput";
import { makeStyles } from "@mui/styles";
// import { customTheme as theme } from "../../../theme/customTheme";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FocusTrap from "@mui/base/FocusTrap";
import useValidator from "../../../hooks/useValidator";
import { userSignin } from "../../../services/api";
import { afterValidate, setInput } from "../../../utils/commonServices";
import { updateState } from "../../../redux/commonSlice";
// import ForgotPasswordPopup from "./ForgotPasswordPopup";
import useAuthRequest from "../../../hooks/useAuthRequest";
// import EmailVerificationPopup from "./EmailVerificationPopup";
// import CustomSnackbar from "../../components/CustomSnackbar";
// import CustomSnackbarDrawer from "../../components/CustomSnackbarDrawer";
import movieIcon from '../../../assets/movieIcon.svg';
import { Box, Grid, Paper, Typography } from '@mui/material';
import UnauthLayout from '../components/UnauthLayout'
import CustomButton from "../../../components/CustomButton";
import { LoadingButton } from "@mui/lab";
import EmailVerificationPopup from "./components/EmailVerificationPopup";
import { gaEvents } from "../../../ga/actions";
import { PRODUCT_ID } from "../../../constants/constants";
import useCustomTheme from "../../../theme/useCustomTheme";
import useUnauthActions from "../useUnauthActions";


const useStyles = makeStyles((theme) => ({
  center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    minHeight: "100%",
  },
}));

const SignIn = () => {

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const forgotPasswordFlag = query.get("forgot-password");
  const token = query.get("token");
  const [openEmailVerificationPopup, setEmailVerificationPopup] = useState(
    token ? true : false
  );

  const classes = useStyles();
  const [pageData, setPageData] = useState({
    email: "",
    password: "",
  });
  const [errorObjectArray, checkEmptyFields, checkValue] = useValidator(
    pageData,
    "signin"
  );
  const [snackbarProps, setSnackbarProps] = useState({});
  const [theme ] = useCustomTheme()
  //const [signin, signinStatus] = useAuthRequest("signin", setSnackbarProps);
   const {signinUser} = useUnauthActions()
   const pendingCallReducer = useSelector((state)=> state.pendingCallReducer)
  const [openForgotPopup, setOpenForgotPopup] = useState(
    forgotPasswordFlag ? forgotPasswordFlag : false
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //Submit button handler function

  const submitClickHandler = async (event) => {
    await checkEmptyFields(event);
   // await checkValue(event);
    afterValidate(afterValidatCallback);
  };

  const afterValidatCallback = () => {
    signinUser({product_id: PRODUCT_ID.pharaoh, param : pageData})
  };
  const forgotPasswordClickHandler = () => {
    // setOpenForgotPopup(true)
    navigate("/forgotpassword", {replace: true});
  };

  //code to detect enter key for editing Organization Name
  useEffect(() => {
    const keyDownHandler = (event) => {
      // console.log("key Parent", event.key)
      if (event.key === "Enter") {
        event.preventDefault();

        submitClickHandler(event);
      }
    };
    openForgotPopup === false
      ? document.addEventListener("keydown", keyDownHandler)
      : document.removeEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [pageData, openForgotPopup]);
  // useEffect(() => {
  //   // if (signupStatus == "success") {
  //   //   setOpenSuccessPopup(true);
  //   // }
  //    //if (signinStatus == "unverified") {
  //     // setOpenSuccessPopup(true);
  //     // navigate('/resendlink', {state: pageData})
  //     navigate('/resendlink', {state: {pageData: pageData, title: 'Your email verification is pending', icon: movieIcon, btnText: 'Resend Email', message:'please check your email and click on the verify now button to continue.', signIn: true}, replace:true})
  //    }
  // }, [signinStatus]);

 // console.log(window.AppleID)

  return (
    <UnauthLayout signin>
      <Box className={classes.center} square component="Box">

        <Box container justifyContent="flex-start" spacing={3}>
          <Box item xs={11} sm={8} md={7}>
            <Box sx={{marginY:{xs:'15px',md:'20px',lg:'25px',xl:'38px'}}}>
              <Typography
                variant="h4"
                color="primary"
                style={{
                  fontWeight: 600,
                  color:'#08231B'
                }}
                sx={{fontSize:{xs:'30px',sm:'40px',md:'47px',lg:'54px',xl:'80px'}, fontFamily:'Rubik'}}
              >
                Welcome back.
              </Typography>
            </Box>
          </Box>

          <Box item xs={11} sm={8} md={7} gap={0.8} sx={{display:'flex', flexDirection:'column',}}>
            <CustomInput
              id={errorObjectArray[0]?.id}
              onFocus={checkEmptyFields}
              onBlur={checkValue}
              required
              errorFlag={errorObjectArray[0]?.errorFlag}
              errorMsg={errorObjectArray[0]?.error}
              // label="Email Address*"
              type="text"
              max={40}
              placeholder="Email Address*"
              onChange={(event) => {
                setInput(
                  pageData?.email != ""
                    ? event.target.value
                    : event.target.value.trim(),
                  "email",
                  pageData,
                  setPageData
                );
                checkEmptyFields(event);
              }}
              value={pageData?.email}
            />
            <CustomInput
              id={errorObjectArray[1]?.id}
              onFocus={checkEmptyFields}
            //  onBlur={checkValue}
              required
              errorFlag={errorObjectArray[1]?.errorFlag}
              errorMsg={errorObjectArray[1]?.error}
              // label="Password*"
              type="password"
              max={40}
              placeholder="Password*"
              onChange={(event) => {
                setInput(
                  pageData?.password != ""
                    ? event.target.value
                    : event.target.value.trim(),
                  "password",
                  pageData,
                  setPageData
                );
                checkEmptyFields(event);
              }}
              value={pageData?.password}
            />
          </Box>
          <Box
            item
            xs={11}
            sm={8}
            md={7}
            style={{ display: "flex", flexDirection: "row", paddingTop: 0 }}
            sx={{ justifyContent: { xs: "center", sm: "flex-end" } }}
          >
            <Box maxWidth="140px" pt={1}>
              <Typography
                onClick={forgotPasswordClickHandler}
                style={{ cursor: "pointer", color: '#08231B' , letterSpacing:'0.55px'}}
                sx={{fontSize:{xs:'8px',md:'9px',xl:'11px'}, fontFamily:'Rubik', fontWeight:600}}
              >
                Forgot password ?
              </Typography>
            </Box>

          </Box>
          <Box item xs={11} sm={8} md={7}>
            <Box
              container
              justifyContent="space-between"
              sx={{
                flexDirection: { xs: "column-reverse", sm: "row" },
                alignItems: "center",
                paddingTop: 0,
              }}
            >
            
              <Box item xs={8} sm={4} sx={{display:'flex', justifyContent:'flex-end', marginTop:{xs:'20px',sm:'28px',md:'28px',lg:'33px',xl:'50px'}}}>
                {/* <CustomButton
                  disabled={signinStatus == "loading"}
                  btnText="Login"
                  variant="contained"
                  color="primary"
                  size="medium"
                  onClick={submitClickHandler}
                  style={{borderRadius: '5px', backgroundColor:'#08231B', color:theme.palette.primary.main, textTransform:'none', }} 
                  sx={{height:{xs:'18px',sm:'20px',md:'22px', lg:'23px', xl:'35px'}, width:{xs:'70px', lg:'90px',xl:'129px'}, fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, fontFamily:'Rubik', fontWeight:600,}}
                /> */}
                 <LoadingButton
                   // size="small"
                    disabled={pendingCallReducer?.signin}
                    onClick={submitClickHandler}
                    style={{borderRadius: '5px', backgroundColor:'#08231B', color:'#21D644', textTransform:'none', }} 
                    sx={{height:{xs:'18px',sm:'20px',md:'22px', lg:'23px', xl:'35px'}, width:{xs:'70px', lg:'90px',xl:'129px'}, fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, fontFamily:'Rubik', fontWeight:600,  minWidth: '94px !important' }}
                   // sx={{ fontSize:{xs:'9px',sm:'9px',md:'9px',lg:'11px',xl:'16px', },fontWeight:600, width:{xs:'76px',sm:'76px',md:'76px',lg:'86px',xl:'129px'},  opacity: !checked && 0.7, minWidth: '110px !important'}}
                    loading={pendingCallReducer?.signin}
                    loadingPosition="start"
                 // loading = {true}
                    variant="contained"
                    >
                   Login
               </LoadingButton> 
              </Box>
              <Box
                sx={{ marginTop: { xs:'40px',sm:'50px',md:'60px',lg:'75px',xl:'120px' } }}
                item
                xs={12}
                sm={8}
                textAlign='center'
              >
              <Typography sx={{fontSize:{xs:'10px',sm:'11px',md:'12px',lg:'13px',xl:'20px'}, fontFamily:'Rubik', color:'#000000'}}>
               {`Don’t have an account? `} 
               <Typography component='span' style={{
                    textDecoration: "none",
                    fontWeight:600,
                    color:'#000000'
                  }}
                  sx={{fontSize:{xs:'10px',sm:'11px',md:'12px',lg:'13px',xl:'20px'}, fontFamily:'Rubik', color:'#000000', fontWeight:600}}
                >
               Contact your Lucihub admin
               </Typography >
                {/* <Link
                  to="/signup"
                  style={{
                    textDecoration: "none",
                    fontWeight:600,
                    color:'#000000'
                  }}
                  sx={{fontSize:{xs:'10px',sm:'11px',md:'12px',lg:'13px',xl:'20px'}, fontFamily:'Rubik', color:'#000000', fontWeight:600}}
                >
                  Create a new account.
                </Link> */}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
       

      </Box>
      {openEmailVerificationPopup && (
        <EmailVerificationPopup
          openHandler={openEmailVerificationPopup}
          closeHandler={setEmailVerificationPopup}
          token={token}
          forgotPopupHandler={setOpenForgotPopup}
        />
      )}
    </UnauthLayout>
  )
}

export default SignIn
